import * as actionTypes from './actionTypes';

export const updateTileData = tile => ({
  type: actionTypes.UPDATE_TILE_DATA,
  payload: { ...tile },
});

export const setTilesData = tiles => ({
  type: actionTypes.SET_TILES_DATA,
  payload: { ...tiles },
});

export const setTilesState = data => ({
  type: actionTypes.SET_TILES_STATE,
  payload: { ...data },
});

export const addCompletionAndPointsToProgressBar = data => ({
  type: actionTypes.ADD_COMPLETION_AND_POINTS_TO_PROGRESS_BAR,
  payload: { ...data },
});
